import { LitElement, html, css } from 'lit';
import { property } from 'lit/decorators.js';
import * as d3 from 'd3';

export class ChartBase extends LitElement {
  static override styles = css`
    :host {
      display: flex;
      width: inherit;
      height: inherit;
    }
    #container {
      display: flex;
      flex: 1 1 auto;
      width: inherit;
      height: inherit;
    }
  `;

  get chartContainer() {
    return this.renderRoot.querySelector('#container') as HTMLDivElement;
  }

  observedElement: HTMLElement | null = null;

  resizeObserver: ResizeObserver | null = null;

  svg: d3.Selection<SVGSVGElement, unknown, null, undefined> | null = null;

  @property({ type: String, attribute: true })
  renderer: 'canvas' | 'svg' = 'svg';

  override connectedCallback() {
    super.connectedCallback();
  }

  override disconnectedCallback() {
    super.disconnectedCallback();
    if (this.observedElement) {
      this.resizeObserver?.unobserve(this.observedElement);
    }
  }

  override firstUpdated(changedProperties: Map<PropertyKey, unknown>) {
    super.firstUpdated(changedProperties);
    this.initChart();
    this.observedElement = this.parentElement;
    if (this.observedElement) {
      this.resizeObserver = new ResizeObserver((_entries) => {
        const { width, height } = getComputedStyle(this.chartContainer);
        this.svg?.attr('width', width).attr('height', height);
        this.resizeChart();
      });
      this.resizeObserver.observe(this.observedElement);
    }
  }

  override render() {
    return html` <div id="container"></div> `;
  }

  override updated(_p: Map<PropertyKey, unknown>) {
    super.updated(_p);

    this.updateChart();
  }

  updateChart() {}

  initChart() {
    const { width, height } = getComputedStyle(this.chartContainer);
    this.svg = d3
      .select(this.chartContainer)
      .append('svg')
      .attr('width', width)
      .attr('height', height);
  }

  resizeChart() {
    const { width, height } = getComputedStyle(this.chartContainer);
    this.svg?.attr('width', width).attr('height', height);
  }
}
